import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import { GET, httpOk } from 'helpers/api'
import { formatDate } from 'helpers/helpers'

// Hafta kunlari — tarjima kalitlari (yakshanbadan boshlanadi, getDay() bilan mos)
const WD = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']

const timeOnly = (dt) => (dt ? formatDate(dt, 'HH:mm') : '—')

// Daqiqani "7 soat 45 daq" ko'rinishiga keltiradi (birliklar tarjima qilinadi)
function hm(mins, t) {
	if (mins === null || mins === undefined) return '—'
	const m = Number(mins)
	if (!m) return '0'
	const h = Math.floor(m / 60)
	const r = m % 60
	if (!h) return `${r} ${t('minute')}`
	return r ? `${h} ${t('hour')} ${r} ${t('minute')}` : `${h} ${t('hour')}`
}

/**
 * Bitta xodimning oylik davomat hisoboti.
 * Oylik jadvalda ism ustiga bosilganda ochiladi.
 */
function EmployeeMonthModal({ show, employeeId, month, restDays, onClose }) {
	const { t } = useTranslation()
	const [data, setData] = useState(null)

	async function load() {
		setData(null)
		const res = await GET('/attendance/employee-month', { employee_id: employeeId, month }, { loader: false })
		if (httpOk(res)) setData(res.data)
	}

	useEffect(() => {
		if (show && employeeId) load()
	}, [show, employeeId, month]) // eslint-disable-line react-hooks/exhaustive-deps

	// Kelmagan kunlar ham ko'rinsin — oyning hamma kunini chizamiz
	function buildRows() {
		if (!data) return []
		const [y, m] = month.split('-').map(Number)
		const total = new Date(y, m, 0).getDate()
		const byDate = {}
		data.days.forEach((d) => { byDate[String(d.work_date).slice(0, 10)] = d })

		return Array.from({ length: total }, (_, i) => {
			const day = i + 1
			const iso = `${month}-${String(day).padStart(2, '0')}`
			const dow = new Date(y, m - 1, day).getDay()
			return { day, iso, dow, rest: (restDays || []).includes(dow), rec: byDate[iso] || null }
		})
	}

	const rows = buildRows()

	// Jamlanma BACKENDDAN olinadi — bu yerda qayta sanamaymiz.
	// Ilgari reduce bilan hisoblanardi va u oylik gridning «Jami» ustuni bilan
	// uchinchi mustaqil hisob bo'lib qolardi: qoida o'zgarsa ikkisi ajralib ketardi.
	const T = data ? data.totals : null
	const summary = {
		days: T ? Number(T.days) : 0,
		minutes: T ? Number(T.worked_minutes) : 0,
		lateDays: T ? Number(T.late_days) : 0,
		lateMinutes: T ? Number(T.late_minutes) : 0,
		incomplete: T ? Number(T.incomplete_days) : 0,
		invalid: T ? Number(T.invalid_days) : 0,
	}

	return (
		<Modal show={show} animation={false} centered size="lg" backdrop="static" onHide={onClose}>
			<Modal.Header closeButton>
				<Modal.Title style={{ fontSize: '17px' }}>
					{data ? data.employee.name : t('loading')}
					<span className="text-muted ms-2" style={{ fontSize: '13px', fontWeight: 400 }}>
						{formatDate(month + '-01', 'MM.yyyy')}
					</span>
				</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				{!data && <div className="text-center text-muted py-4">{t('loading')}</div>}

				{data &&
					<>
						{/* JAMLANMA */}
						<div className="row g-2 mb-3">
							{[
								{ l: t('days_present'), v: summary.days, c: '#0f9d58', b: '#e6f7ee' },
								{ l: t('worked_time'), v: hm(summary.minutes, t), c: '#1a73e8', b: '#e8f0fe' },
								{ l: t('came_late'), v: summary.lateDays ? `${summary.lateDays} ${t('day')}` : '0', c: '#b8860b', b: '#fef7e0' },
								{ l: t('lateness'), v: hm(summary.lateMinutes, t), c: '#d93025', b: '#fce8e6' },
							].map((s, i) => (
								<div className="col-6 col-md-3" key={i}>
									<div className="p-2 rounded text-center" style={{ background: s.b }}>
										<div style={{ fontSize: '11.5px', color: s.c }}>{s.l}</div>
										<div className="fw-bold" style={{ color: s.c, fontSize: '16px' }}>{s.v}</div>
									</div>
								</div>
							))}
						</div>

						{summary.incomplete > 0 &&
							<div className="alert alert-warning py-2 px-3" style={{ fontSize: '12.5px' }}>
								<i className="uil-exclamation-triangle me-1"></i>
								{t('incomplete_days_warn', { n: summary.incomplete })}
							</div>
						}

						{summary.invalid > 0 &&
							<div className="alert alert-danger py-2 px-3" style={{ fontSize: '12.5px' }}>
								<i className="uil-times-circle me-1"></i>
								{t('invalid_days_warn', { n: summary.invalid })}
							</div>
						}

						{/* KUNLIK JADVAL */}
						<div className="table-responsive" style={{ maxHeight: '52vh' }}>
							<table className="table table-sm mb-0 align-middle" style={{ fontSize: '13px' }}>
								<thead>
									<tr className="text-muted" style={{ fontSize: '12px' }}>
										<th style={{ position: 'sticky', top: 0, background: 'var(--dk-surface-2, #f8f9fa)', width: '18%' }}>{t('date')}</th>
										<th style={{ position: 'sticky', top: 0, background: 'var(--dk-surface-2, #f8f9fa)' }} className="text-center">{t('check_in')}</th>
										<th style={{ position: 'sticky', top: 0, background: 'var(--dk-surface-2, #f8f9fa)' }} className="text-center">{t('check_out')}</th>
										<th style={{ position: 'sticky', top: 0, background: 'var(--dk-surface-2, #f8f9fa)' }} className="text-center">{t('worked')}</th>
										<th style={{ position: 'sticky', top: 0, background: 'var(--dk-surface-2, #f8f9fa)' }} className="text-center">{t('lateness')}</th>
										<th style={{ position: 'sticky', top: 0, background: 'var(--dk-surface-2, #f8f9fa)' }} className="text-center">{t('days_count')}</th>
									</tr>
								</thead>
								<tbody>
									{rows.map((r) => {
										const rec = r.rec
										const late = rec && Number(rec.late_minutes) > 0
										return (
											<tr key={r.day} style={{ background: r.rest ? 'var(--dk-weekend-bg, #fdf4f3)' : (rec ? 'var(--dk-surface, #fff)' : '#fafafa') }}>
												<td className="text-nowrap">
													<span className="fw-semibold">{String(r.day).padStart(2, '0')}</span>
													<span className="text-muted ms-1" style={{ fontSize: '11.5px' }}>{t(WD[r.dow]).slice(0, 3)}</span>
												</td>
												<td className="text-center">
													{rec ? <span className={late ? 'text-danger fw-semibold' : ''}>{timeOnly(rec.check_in_at)}</span> : '—'}
												</td>
												<td className="text-center">
													{rec
														? (rec.check_out_at
															? timeOnly(rec.check_out_at)
															: <span className="text-warning" title={t('no_checkout')}>—</span>)
														: '—'}
												</td>
												<td className="text-center">{rec ? hm(rec.worked_minutes, t) : '—'}</td>
												<td className="text-center">
													{late
														? <span className="badge bg-warning text-dark" style={{ fontSize: '10.5px' }}>{hm(rec.late_minutes, t)}</span>
														: (rec ? <span className="text-muted">—</span> : '—')}
												</td>
												<td className="text-center fw-semibold">
													{!rec
														? (r.rest ? <span className="text-muted" style={{ fontSize: '11px' }}>{t('rest_short')}</span> : <span className="text-muted">0</span>)
														: (Number(rec.day_value) === 0
															? <span className="text-muted" title={t('no_check_in_title')}>0</span>
															: Number(rec.day_value) === 0.5
																? <span className="text-warning">0.5</span>
																: <span className="text-success">1</span>)}
												</td>
											</tr>
										)
									})}
								</tbody>
							</table>
						</div>

						<p className="text-muted mb-0 mt-2" style={{ fontSize: '11.5px' }}>
							{t('work_time')}: <b>{data.work_time.start}–{data.work_time.end}</b>
							{data.work_time.tolerance > 0 && <> · {t('tolerance_short')} <b>{data.work_time.tolerance} {t('minute')}</b></>}
							· {t('half_day_threshold')} <b>{hm(Math.round(data.work_time.norm / 2), t)}</b>
						</p>
					</>
				}

				<div className="d-flex justify-content-end mt-3">
					<button type="button" className="btn btn-outline-secondary" onClick={onClose}>{t('close')}</button>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default EmployeeMonthModal
